import { Injectable } from '@angular/core';
import { FollowupActionStatusReason, FollowupActionType } from '../../classes/activity/follow-up-action.activity.class';
import { BrandOfflineService } from '@omni/services/brand/brand.service';
import { Brand } from '../../classes/brand/brand.class';

@Injectable({
  providedIn: 'root'
})
export class FollowupService {

  followupActionTypes: FollowupActionType[] = [];
  public followupActionStatusReasons: FollowupActionStatusReason[] = [];
  brandProducts: Array<Brand> = new Array<Brand>();

  constructor(private brandService: BrandOfflineService) {

    this.brandProducts = this.brandService.brands; // Thsi is to get the brands  mapped to user's position
    this._sortBrands(); // Apply sorting based on the name alphabetically ascending

  }

  private _sortBrands() {
    if (!this.brandProducts || this.brandProducts.length == 0) return;
    this.brandProducts = this.brandProducts.sort((a, b) => {
      if (a.name.toLowerCase() > b.name.toLowerCase()) {
        return 1;
      }
      if (b.name.toLowerCase() > a.name.toLowerCase()) {
        return -1;
      }
    });
  }
}
